import axios from './util/axios.js'

export function getOutfitFormulas() {
  return axios.get('/api/outfitformulas/')
}
